export default __webpack_public_path__ + "static/media/p2023-22.01122dde.jpeg";